// extracted by mini-css-extract-plugin
module.exports = {"container":"Layout_container__21Rhq","header":"Layout_header__Ev0Fg","content":"Layout_content__2A35J","footer":"Layout_footer__3uXvv"};